<section class="container-fluid-1100" id="content">

  <div><!-- breadcrumbs --></div>

  <!-- for SEO -->
  <ng-container *ngIf="title">
      <h1 class="hide-accessible">{{title}}</h1>

      <!-- title -->
      <section class="portlet">
        <div class="portlet-content">
          <div class="portlet-content-container">
            <div class="portlet-body">
              <h2 class="corruption__title">{{title}}</h2>
            </div>
          </div>
        </div>
      </section>
  </ng-container>

  <!-- content -->
  <div class="columns-1" id="main-content" role="main">
    <div class="portlet-layout row">
      <div class="col-md-12 portlet-column portlet-column-only" id="column-1">
        <router-outlet (activate)='onActivate($event)'></router-outlet>
      </div>
    </div>
  </div>
</section>
